import { createFileRoute, useNavigate } from "@tanstack/react-router"
import type { FC } from "react"
import { useEffect } from "react"
import { useAuthSession } from "~/hooks/useAuthSession"

const LoginFormWithDescription: FC = () => {
  const navigate = useNavigate()

  // Session
  const { session, status } = useAuthSession()

  useEffect(() => {
    if (session?.user?.id) {
      void navigate({ to: "/" })
    } else {
      void navigate({ to: "/auth/signin" })
    }
  }, [session, navigate])

  if (session?.user?.id) {
    return <></>
  }

  return null
}

function AuthErrorPage() {
  return <LoginFormWithDescription />
}

export const Route = createFileRoute("/auth/error/$")({
  component: AuthErrorPage,
})
